import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
  const { isAuth } = useSelector((state) => state.auth)

  if (!isAuth) {
    return <Navigate to="/Login" replace />
  }

  return children
}

export default PrivateRoute